import axios from 'axios'
import queryString from 'query-string'
import {storageGet, storageSet} from "./utils/storage";

export function loginWithCredentials(email, password) {
    return axios.post(process.env.MIX_API_URL + '/login', {email: email, password: password}).then((res) => {
        storageSet('token', res.data.token)
        setToken(res.data.token)
        return Promise.resolve(res);
    }).catch((err) => {
        return Promise.reject(err);
    });
}

export function loginWithToken() {
    const parsedQueryString = queryString.parse(window.location.search);

    let token = parsedQueryString['token']

    if (!token) {
        token = storageGet('token')
        try {
            token = JSON.parse(token)
        } catch (e) {
        }
    }

    if (token) {
        setToken(token)

        return axios.get(process.env.MIX_API_URL + '/token').then((res) => {
            storageSet('token', res.data.token)
            setToken(res.data.token)
            return Promise.resolve(res);
        }).catch((err) => {
            return Promise.reject(err);
        });
    }
    return Promise.reject('No token in storage.');
}

export function logout() {
    storageSet('token', '')
    setToken('')
    location = '/';
}

export function relogWithToken(token) {
    storageSet('token', token)
    setToken(token)
    location = '/';
}

export function setToken(token) {
    axios.defaults.headers.common = {'Authorization': 'Bearer ' + token, 'Accept': 'application/json'}
}

export function getApplication(id) {
    return axios.get(process.env.MIX_API_URL + '/application/' + id)
}

export function postApplicationAction(id, action) {
    return axios.post(process.env.MIX_API_URL + '/application/action/' + id, {action: action})
}

export function sendPassword(ssn) {
    return axios.post(process.env.MIX_API_URL + '/login/send-password', {ssn: ssn}).then((res) => {
        storageSet('token', res.data.token)
        setToken(res.data.token)
        return Promise.resolve(res);
    }).catch((err) => {
        return Promise.reject(err);
    });
}

export function sendAuthPinCode(pinCode, pinCodeToken) {
    return axios.post(process.env.MIX_API_URL + '/login/pin-code', {
        pinCode: pinCode,
        pinCodeToken: pinCodeToken
    }).then((res) => {
        storageSet('token', res.data.token)
        setToken(res.data.token)
        return Promise.resolve(res);
    }).catch((err) => {
        return Promise.reject(err);
    });
}

export function sendMessage(message) {
    return axios.post(process.env.MIX_API_URL + '/message', message).then(res => res.data)
}

export function storeOffer(offer) {
    return axios.post(process.env.MIX_API_URL + '/offer', offer).then(res => res.data)
}

export function postItemUpdate(boat) {
    return axios.post('/api/admin/update-item', boat).then(res => res.data)
}

export function updateStatsCache() {
    return axios.get(`/api/admin/update-stats`).then(res => res.data)
}

export function sendSms(userId, content) {
    return axios
        .post(`/api/admin/send-sms`, {userId: userId, content: content})
        .then(res => res.data)
}

export function postRequest(url, payload) {
    return axios
        .post(url, payload)
        .then(res => res.data)
}

export function getBooking(processId) {
    return axios.get(`/api/booking/process/${processId}`).then(res => res.data)
}

export function updateBookingPrice(processId, price, deposit) {
    return axios.put(`/api/booking/process/${processId}/price`, {
        price,
        deposit
    })
}

export function getProjectSettings(payload) {
    const qStr = `${process.env.MIX_API_URL}/project?${queryString.stringify(payload)}&ts=${Date.now()}`
    return axios.get(qStr);
}

export function saveProjectSetting(payload) {
    return axios
        .post(`${process.env.MIX_API_URL}/project/update`, payload)
        .then(res => res.data)
}

export function createProjectSetting(payload) {
    return axios
        .post(`${process.env.MIX_API_URL}/project/store`, payload)
        .then(res => res.data)
}

export function deleteProjectSetting(payload) {
    return axios
        .post(`${process.env.MIX_API_URL}/project/delete`, payload)
        .then(res => res.data)
}

export function attachProjectSetting(payload) {
    return axios
        .post(`${process.env.MIX_API_URL}/project/attach`, payload)
        .then(res => res.data)
}

export function detachProjectSetting(payload) {
    return axios
        .post(`${process.env.MIX_API_URL}/project/detach`, payload)
        .then(res => res.data)
}

export function createChildProjectSetting(payload) {
    return axios
        .post(`${process.env.MIX_API_URL}/project/store-child`, payload)
        .then(res => res.data)
}

export function getMetaData() {
    return axios
        .get(`${process.env.MIX_API_URL}/meta`)
        .then(res => res.data)
}

export function loginAsUser(userId) {
    return axios
        .get(`${process.env.MIX_API_URL}/auth/loginAs?userId=${userId}`)
        .then(res => res.data)
}

export function getSegmentSelectLists(from, to, filters, filterBasedOnField) {
    const qStr = `?${queryString.stringify(filters)}&from=${from.format('YYYY-MM-DD')}&to=${to.format('YYYY-MM-DD')}&baseField=${filterBasedOnField}&ts=${Date.now()}`
    return axios.get(process.env.MIX_API_URL + '/dashboard/segment-select-lists' + qStr);
}
